import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export interface IParams {
  categoryId: number
  endTime: string
  pageNo: number
  pageSize: number
  startTime: string
  group?: boolean
}

class FetchRecentLiveStreamingProductListApi extends Service {
  constructor(params: IParams) {
    super()
    this.name = 'FETCH_RECENT_LIVE_STREAMING_PRODUCT_LIST'

    this.config = {
      url: `/v1/product/product-live-time/queries`,
      method: 'POST',
      data: { ...params },
    }
  }
}

export const fetchRecentLiveStreamingProductList = (params: IParams) => getCallApiFunction(new FetchRecentLiveStreamingProductListApi(params))
